import { OfferOptionDto, OfferOptionTypeDto } from 'src/dtos';
import { OfferOption } from 'src/models';

export const mapOfferOptionDtoToModel = (dto: OfferOptionDto, type: OfferOptionTypeDto): OfferOption => ({
  ...dto,
  type,
});
